export default import.meta.ROLLDOWN_FILE_URL_HFnjJDCDlZD6uFPXE2$ebQ